<template>
  <!-- App Capsule -->
  <Header />

  <div id="appCapsule">
    <!-- loader -->

    <!-- * loader -->
    <div>
      <div class="section mt-2">
        <div class="text-center mb-2">
          <div class="avatar">
            <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar" class="imaged w100 rounded" />
          </div>
          <div v-if="profile.ratingDriver != null" class="mt-1" style="display:inline-block;">
            <star-rating :inline="true" :star-size="20" :read-only="true" :show-rating="false"
              :rating="profile.ratingDriver"></star-rating>
          </div>
        </div>
      </div>

      <ul v-if="loading" class="listview image-listview placeholder-glow mb-2">
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-primary placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-4"></span>
              <span class="placeholder col-2"></span>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-secondary placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-2"></span>
              <span class="placeholder col-1"></span>
            </div>
          </a>
        </li>
        <li>
          <a href="#" class="item">
            <div class="icon-box bg-danger placeholder">
            </div>
            <div class="in">
              <span class="placeholder col-5"></span>
            </div>
          </a>
        </li>
      </ul>

      <ul v-else class="listview link-listview image-listview">
        <li>
          <router-link :to="{ name: 'profileEdit' }" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="person" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                {{ profile.name }} {{ profile.lastName }}
                <footer class="text-TEAL">{{ profile.mobileNumber }}</footer>
              </div>
              <span class="text-muted">ویرایش</span>
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'profileEdit' }" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="finger-print" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                احراز هویت
                <footer class="text-TEAL" v-if="profile.authStatus == 0">
                  {{ profile.driverAuthStatusTitles[0] }}
                </footer>
                <footer class="text-TEAL" v-if="profile.authStatus == 1">
                  {{ profile.driverAuthStatusTitles[1] }}
                </footer>
                <footer class="text-TEAL" v-if="profile.authStatus == 2">
                  {{ profile.driverAuthStatusTitles[2] }}
                </footer>
                <footer class="text-TEAL" v-if="profile.authStatus == 3">
                  {{ profile.driverAuthStatusTitles[3] }}
                </footer>
              </div>
            </div>
            <span class="text-muted">ویرایش</span>
          </router-link>
        </li>
        <li>
          <a href="#" data-bs-toggle="offcanvas" data-bs-target="#actionSheetForm" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="car" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                ناوگان
                <footer class="text-TEAL">{{ profile.fleetTitle }}</footer>
              </div>
            </div>
            <span class="text-muted">انتخاب</span>
          </a>
        </li>
        <!-- <li>
          <a href="#" data-bs-toggle="offcanvas" :data-bs-target="'#actionSheetContent_' + profile.id" @click="offPardakht" class="item">
            <div class="icon-box background-TEAL text-light text-light">
              <ion-icon name="calendar" role="img" class="md hydrated" aria-label="image outline"></ion-icon>
            </div>
            <div class="in">
              <div>
                <span>خرید اشتراک</span>
                <footer class="text-TEAL">
                  روز های باقی مانده:
                  <span v-bind:class="{
                    'text-danger': diffDays == 0,
                    'text-success': diffDays !== 0,
                  }">{{ diffDays }} روز</span>
                </footer>
              </div>
            </div>
            <span class="text-muted">خرید</span>
          </a>
        </li> -->
      </ul>
      <!-- Form Action Sheet -->
      <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
        <div class="offcanvas-header background-TEAL">
          <h5 class="offcanvas-title text-light">انتخاب ناوگان ({{ profile.fleetTitle }})</h5>
        </div>
        <div class="offcanvas-body">
          <form @submit.prevent="changeFleet">
            <div class="form-group basic">
              <div class="input-wrapper">
                <div class="section full mt-2">
                  <div class="section-title" style="justify-content: center !important;">لطفا ناوگان مورد نظر خود را
                    انتخاب کنید</div>

                  <div class="accordion" id="accordionExample1">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion5">
                          نیسان و وانت
                        </button>
                      </h2>
                      <div id="accordion5" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms5" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion1">
                          کامیونت
                        </button>
                      </h2>
                      <div id="accordion1" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">

                            <div class="form-check" v-for="fleet in fleets.coms1" :key="fleet.id">
                              <input class="form-check-input" :value="fleet.id" type="radio" name="radioList"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion2">
                          کامیون 6 چرخ (تک)
                        </button>
                      </h2>
                      <div id="accordion2" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms2" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion3">
                          کامیون 10 چرخ (جفت)
                        </button>
                      </h2>
                      <div id="accordion3" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms3" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#accordion4">
                          تریلی
                        </button>
                      </h2>
                      <div id="accordion4" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                        <div class="accordion-body">
                          <div class="input-list">
                            <div class="form-check" v-for="fleet in fleets.coms4" :key="fleet.id">
                              <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                :id="'radioList' + fleet.id" v-model="postData.fleet_id">
                              <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="form-group basic">
              <button type="submit" data-bs-dismiss="offcanvas" class="btn background-ORANGE text-light btn-block">
                ثبت
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- <Peyment :driver_id="postData.driver_id" :data="profile.id" /> -->
      <!-- * Form Action Sheet -->

      <div class="listview-title mt-2">شماره پلاک</div>
      <div class="container text-center">
        <div class="btn-group btn-group-lg d-flex" v-if="profile.vehicleLicensePlatePartD !== ''">
          <button type="button" class="btn btn-outline-secondary" style="border-radius: 0px 4px 4px 0px !important;">
            {{ profile.vehicleLicensePlatePartD }}
          </button>
          <button type="button" class="btn btn-outline-secondary" style="border-left: none;">{{
            profile.vehicleLicensePlatePartC }}</button>
          <button type="button" class="btn"
            style="border-top: 1px solid #6c7c94; border-bottom: 1px solid #6c7c94; border-left: none;">{{
            profile.vehicleLicensePlatePartB }}</button>
          <button type="button" class="btn btn-outline-secondary" style="border-right: none;">{{
            profile.vehicleLicensePlatePartA }}</button>
        </div>
        <!-- <div class="input-group input-group-lg" v-if="profile.vehicleLicensePlatePartD !== '' ||
          profile.vehicleLicensePlatePartD !== null
          ">
          <input type="text" disabled :value="profile.vehicleLicensePlatePartD"
            class="form-control background-TAKSI text-center border border-dark" />
          <input type="text" disabled :value="profile.vehicleLicensePlatePartC"
            class="form-control background-TAKSI text-center border border-dark" />
          <input type="text" disabled :value="profile.vehicleLicensePlatePartB"
            class="form-control background-TAKSI text-center border border-dark" />
          <input type="text" disabled :value="profile.vehicleLicensePlatePartA"
            class="form-control background-TAKSI text-center border border-dark" />
        </div> -->
        <!-- <div v-else>
          <div class="mb-05">شماره پلاک ثبت نشده است</div>
        </div> -->
      </div>
      <div class="container">
        <div class="row g-3 mt-2">
          <div class="col-6">
            <router-link :to="{ name: 'term' }" class="btn background-ORANGE text-light btn-block">قوانین و
              مقررات</router-link>
          </div>
          <div class="col-6">
            <a class="btn background-ORANGE text-light btn-block" :href="'tel:' + tel">تماس با پشتیبانی</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->
  <Footer v-show="isLoggedIn" />

</template>
<script>
import axios from "axios";
// import { ref } from "vue";
import Swal from "sweetalert2";
// import Peyment from "../../components/Peyment.vue";
import StarRating from 'vue-star-rating'
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  components: {
    // Peyment,
    StarRating,
    Header,
    Footer
  },
  data() {
    return {
      postData: {
        driver_id: window.localStorage.getItem("idUser"),
        fleet_id: "",
      },
      fleets: {
        coms1: [],
        coms2: [],
        coms3: [],
        coms4: [],
        coms5: [],
      },
      tel: window.localStorage.getItem("tel"),
      time: [],
      loading: false,
      profile: [],
      diffDays: [],
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
    };
  },
  methods: {
    getworkorderdetail: function () {
      this.loading = true;
      let workorder = axios.get(`https://core.iran-tarabar.ir/api/driver/getDriverProfileInfo`, this.axiosConfig)
        .then((response) => {
          this.loading = false;
          var d1 = new Date();
          var d2 = new Date(response.data.data.activeDate);
          var diff = d2.getTime() - d1.getTime();
          var daydiff = diff / (1000 * 60 * 60 * 24);
          if (daydiff < 0) {
            daydiff = 0;
          }
          this.$cookies.set("profile", { data: response.data.data }, "10min");
          this.profile = response.data.data;
          this.diffDays = Math.round(daydiff);
        });
      return workorder;
    },
    offPardakht() {
      localStorage.setItem("offPardakht", this.profile.id);
      if (history.pushState) {
        var newurl = window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?offPardakht=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    changeFleet() {
      axios.post(
        "https://core.iran-tarabar.ir/api/driver/requestChangeFleet",
        this.postData, this.axiosConfig
      )
        .then((res) => {
          this.profile.fleetTitle = res.data.data.fleetTitle;

          // let staff = this.$cookies.get("profile")
          //   ? this.$cookies.get("profile")
          //   : { data: [] };

          // if (staff.data.id) {
          //   staff.data.fleetTitle = res.data.data.fleetTitle
          //   this.$cookies.set("profile", { data: staff.data }, "10min");
          // }
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "با موفقیت تغییر کرد",
            showConfirmButton: false,
            timer: 1000,
          });
        });
    },
  },
  computed: {
    isLoggedIn() {
      return window.localStorage.getItem("idUser");
    },
  },
  async beforeMount() {
    try {
      const response = await axios.get(
        "https://core.iran-tarabar.ir/api/customer/requestAllFleetsList"
      );
      // this.fleets = response.data.fleets;
      this.fleets.coms1 = response.data.fleets.filter(obj => obj.parent_id == 42);
      this.fleets.coms2 = response.data.fleets.filter(obj => obj.parent_id == 43);
      this.fleets.coms3 = response.data.fleets.filter(obj => obj.parent_id == 53);
      this.fleets.coms4 = response.data.fleets.filter(obj => obj.parent_id == 54);
      this.fleets.coms5 = response.data.fleets.filter(obj => obj.parent_id == 81);
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    this.getworkorderdetail();
  }
};
</script>
<style></style>